import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import Navbar from './Navbar';

const Layout = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Hide navbar for protocol pages
  const hideNavbarRoutes = ['/daily-ritual', '/protocol-complete'];
  const shouldHideNavbar = hideNavbarRoutes.includes(location.pathname);

  if (!isAuthenticated) {
    return children;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-teal-50 to-cyan-50">
      {!shouldHideNavbar && <Navbar />}
      <main className={shouldHideNavbar ? '' : 'pt-16'}>
        {children}
      </main>
      
      {/* Floating Create Post Button - Mobile Optimized - Hidden during protocol */}
      {!shouldHideNavbar && location.pathname !== '/create-post' && (
        <button
          onClick={() => navigate('/create-post')}
          className="fixed bottom-4 sm:bottom-6 right-4 sm:right-6 w-14 h-14 sm:w-16 sm:h-16 bg-gradient-to-r from-emerald-500 to-teal-600 text-white rounded-full shadow-2xl hover:shadow-3xl transform hover:scale-110 transition-all duration-300 flex items-center justify-center z-40 min-h-[44px] min-w-[44px]"
          title="Create Post"
        >
          <svg className="w-6 h-6 sm:w-8 sm:h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
        </button>
      )}
    </div>
  );
};

export default Layout;